import { getWindowObject } from '@eb/feature-detection';
/**
 * Safely checks if the window exists and supports eventListeners
 */
export const HAS_WINDOW_LISTENERS = !!getWindowObject('addEventListener');
